module.exports = __webpack_public_path__ + "static/media/license_2021.caf0ecce.pdf";